import { graphql } from 'react-relay';

export const PhotoRootQuery = graphql`
    query PhotoRootQuery($urlLabels: [String!]!) {
        viewer {
            ...InteriorPhotoWrapper_viewer
        }
    }
`;
